import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { IconEditPencil } from '../Icons';
import LinkifyText from '../LinkifyText';

const ContactInfoNotes = ({ note, onEditNote }) => {
  const { t } = useTranslation('components', { keyPrefix: 'ContactInfo' });

  return (
    <div>
      <div className="text-sm text-slate-600 mb-4">{t('note.label')}</div>
      <LinkifyText>
        <div className="mb-4 whitespace-pre-line break-words">{note}</div>
      </LinkifyText>
      <Button className="flex items-center space-x-2" onClick={onEditNote} kind="link">
        <IconEditPencil size="5" />
        <div>{t('note.edit_note')}</div>
      </Button>
    </div>
  );
};

ContactInfoNotes.defaultProps = {
  note: '',
};

ContactInfoNotes.propTypes = {
  note: PropTypes.string,
  onEditNote: PropTypes.func.isRequired,
};

export default ContactInfoNotes;
